// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "preferencecenter",
            "endpoint": "https://api.constellationpreferences.com",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js